// src/theme.js
import { createTheme } from '@mui/material/styles';

const common = {
  direction: 'rtl',
  typography: {
    fontFamily: 'IRANSans, Vazir, Roboto, sans-serif',
    h6: { fontSize: '1rem', fontWeight: 600 },
    body1: { fontSize: '0.95rem' },
    caption: { color: '#6B7280' }
  },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiButton: { styleOverrides: { containedPrimary: { boxShadow: 'none' } } }
  }
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1E6FB8' },
    secondary: { main: '#FFB86B' },
    background: { default: '#F3F6F9', paper: '#FFFFFF' },
    text: { primary: '#172033', secondary: '#6B7280' },
    error: { main: '#E04444' }
  },
  ...common
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#4EA3FF' },
    secondary: { main: '#FFB86B' },
    background: { default: '#0B1220', paper: '#0F1724' },
    text: { primary: '#E6EEF8', secondary: '#A6B0C0' },
    error: { main: '#FF6B6B' }
  },
  ...common
});

export default lightTheme;
